import React, { useEffect, useState } from 'react'
import axios from "axios";
import { useLocation } from 'react-router-dom'
import { adminLoginRequest} from 'store/login/loginActions'
import { connect } from 'react-redux'
import 'less/login-admin.less'
import { Spinner } from '@blueprintjs/core'


import 'less/login.less'

function mapStateToProps(state) {
  return {
    loginSuccessed: state.login.loginSuccessed,
  }
}

const LoginAdmin = (props) => {
  const search = useLocation().search
  const searchParams = new URLSearchParams(search)
  const code = searchParams.get('code')
  const [tokenResp, setTokenResp] = useState({})

  useEffect(async () => {
    const url = `${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/token`;
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      };
                            
      const request = new URLSearchParams();
      request.append('grant_type', 'authorization_code');
      request.append('client_id', process.env.REACT_APP_COGNITO_CLIENT);
      request.append('code', code);
      request.append('redirect_uri', process.env.REACT_APP_COGNITO_REDIRECT);
      // QUAL-2201: never log the request (authorization code), the token response (id/access/refresh
      // tokens) or the axios error (its config.data is the request) - named fields only.
      console.log("requesting Cognito token");

      const resp = await axios.post(url, request, config).then((response) => {
        const { status, data } = response;
        console.log("Cognito token response", { status });

        return {
          statusCode: 200,
          body: data
        };
      }).catch(function (err) {
        console.log("Error has occured: ", {
          status: err && err.response && err.response.status,
          code: err && err.code,
          noResponse: !(err && err.response)
        });
        return err
      });
      props.adminLoginRequest(resp)
      setTokenResp(resp)
  }, [])

  useEffect( () => {
    if (code == null){
      window.location.href=`${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/authorize?response_type=code&client_id=${process.env.REACT_APP_COGNITO_CLIENT}&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT}`
    }
    if (tokenResp.statusCode == 200){
      window.location.href=`/projects`
    }
  }, [tokenResp, code])


  return <Spinner intent="primary" className='login-spinner'/>
}
const mapDispatch = {
  adminLoginRequest,
}

export default connect(mapStateToProps, mapDispatch)(LoginAdmin)
